import {Control, useWatch} from 'react-hook-form';
import {useSelector} from 'react-redux';

import {useEmailConfirmation, userSelector} from 'entities/user';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {getCheckedEmailsCount} from 'features/http/lib/httpNotifyView';
import {countSelected} from 'entities/notification';

export const useNotifyEmail = (control: Control<any>, item?: IHttpMonitorOutput) => {
    const user = useSelector(userSelector);
    const confirmEmail = useEmailConfirmation();

    const isNotifyByEmail = useWatch({
        control,
        name: 'notify_by_email',
        defaultValue: item?.notify_by_email ?? false,
    });

    const selectedAdditionalEmails = useWatch({
        control,
        name: 'additional_emails',
        defaultValue: item?.additional_emails ?? [],
    });

    return {
        user,
        confirmEmail,
        isNotifyByEmail,
        checkedEmailsCount: getCheckedEmailsCount(isNotifyByEmail, countSelected(selectedAdditionalEmails)),
    };
};

export default useNotifyEmail;
